import { render, staticRenderFns } from "./StoreItem.vue?vue&type=template&id=1aa012e9&scoped=true"
import script from "./StoreItem.vue?vue&type=script&lang=js"
export * from "./StoreItem.vue?vue&type=script&lang=js"
import style0 from "./StoreItem.vue?vue&type=style&index=0&id=1aa012e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa012e9",
  null
  
)

export default component.exports